import { gql } from '@apollo/client';

const GET_DASHBOARD_CONFIG = gql`
    query dashboardConfig($id: String!) {
        dashboardConfig(id: $id) {
            id
            title
            config
        }
    }
`;

export default GET_DASHBOARD_CONFIG;
